import * as React from "react";
const IconRe = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 26.666 640 426.666"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <g fillRule="evenodd" strokeWidth="1pt">
      <path  d="M0 0h640v480H0z" />
      <path  d="M0 0h213.3v480H0z" />
      <path  d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
);
export default IconRe;
